/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const PlusSvg = () => (
  <svg width="1em" height="1em" viewBox="1.5 1.5 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6666 7.33301H8.66658V3.33301H7.33325V7.33301H3.33325V8.66634H7.33325V12.6663H8.66658V8.66634H12.6666V7.33301Z" fill="currentColor"/>
  </svg>
);

export const PlusIcon = props => <Icon component={PlusSvg} {...props} />;
